import { useEffect } from 'react'

import { useBrandConfig } from 'contexts/BrandConfigContextProvider'

import useIntercomChat from './useIntercomChat'
import useUser from './useUser'

export default function useLiveChat() {
    const { user } = useUser()
    const { disableIntercom } = useBrandConfig()
    const intercomChat = useIntercomChat()

    useEffect(() => {
        if (user && !disableIntercom) {
            intercomChat.setUser(user)
        }
    }, [intercomChat, user, disableIntercom])

    return intercomChat
}
